import { Filter } from '@classify/react-core-components/FilterContainer';

import type { RefinementList } from '../types';

const mapFiltersToRefinementList = (filters: Filter[]): RefinementList | undefined => {
  const hasFilters = filters.some((filter) => filter.checkedItems.length > 0);
  if (!hasFilters) {
    return undefined;
  }
  return Object.fromEntries(
    filters.map((filter) => [filter.name, filter.checkedItems.map((item) => item.value)])
  );
};

export default mapFiltersToRefinementList;
